import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Text, Selector } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import SortFactory from "./enum/EnumValueSorterFactory.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.imagine.attributes.EnumSelector');
function EnumSelector(props) {
  const {
    attribute,
    textVariant,
    editable,
    value,
    onChange,
    variant,
    eventData,
    enumData,
    toggleVariant,
    disabled,
    usage,
    style
  } = props;
  const valueData = useMemo(() => enumData?.values?.find(v => v?.value === value), [enumData, value]);
  const vnt = textVariant || (usage === 'table' ? 'columnValue' : `${usage}Value`);
  if (!editable || !enumData?.values) {
    if (!valueData?.name && value == null) {
      return null;
    }
    return /*#__PURE__*/_jsx(Text, {
      style: style,
      variant: vnt,
      children: valueData?.name || value
    });
  }
  const valueSortModel = enumData?.metadata?.valueSortModel;
  const values = SortFactory.create(valueSortModel, enumData.values);
  if (enumData?.metadata?.allowNone == null || enumData?.metadata?.allowNone === true) {
    values.unshift({
      name: t('none', {
        attributeName: attribute.displayName
      }),
      value: null
    });
  }
  return /*#__PURE__*/_jsx(Selector, {
    disabled: disabled,
    style: style,
    value: value,
    showFilter: true,
    nameKey: "name",
    valueKey: "value",
    eventData: eventData,
    variant: variant,
    toggleVariant: vnt ? `${toggleVariant}|${vnt}` : toggleVariant,
    values: values,
    onChange: onChange
  });
}
export default connect((state, ownProps) => {
  const {
    getEnumData
  } = ownProps;
  return {
    enumData: getEnumData(state)
  };
})(EnumSelector);